import React from 'react';

/**
 * Component hiển thị error message cho form fields
 * @param {Object} props
 * @param {string} props.error - Error message
 * @param {string} props.className - CSS class name
 * @param {Object} props.style - Inline styles
 * @param {boolean} props.show - Có hiển thị error hay không
 */
const FormErrorMessage = ({ 
    error, 
    className = '', 
    style = {}, 
    show = true 
}) => {
    // Không hiển thị nếu không có error hoặc show = false
    if (!error || !show) return null;

    const defaultStyle = {
        color: '#ff4d4f',
        fontSize: '12px',
        marginTop: '4px',
        display: 'block',
        lineHeight: '1.4'
    };

    const combinedStyle = {
        ...defaultStyle,
        ...style
    };

    return (
        <span 
            className={`form-error-message ${className}`}
            style={combinedStyle}
            role="alert"
            aria-live="polite"
        >
            {error}
        </span>
    );
};

export default FormErrorMessage;
